import React from "react";
import styled from "styled-components";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  InputGroup,
  Label,
  Row,
  Tooltip,
  UncontrolledTooltip,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomSelect from "../../Common/CustomSelect";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import CheckboxCollapse from "../../Common/CheckboxCollapse";
import SelectWithInput from "../../Common/SelectWithInput";
import { connect } from "react-redux";
import { getOfferData } from "../../../store/offers/actions";
import PropTypes from "prop-types";
import { getEvents } from "../../../store/events/actions";
import { getDefaultValueForSelect } from "../../../helpers/utils";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import PaymentType from "./OfferPaymentForm/PaymentType";
import { getMetaCountries } from "../../../store/meta/actions";
import {
  getCampaignAdvertisingAccountsList,
  setCampaignAdvertisingAccountsList,
} from "../../../store/campaigns/advertising-accounts/actions";
import DynamicModalWithInput from "../../DynamicModalWithInput/DynamicModalWithInput";
import CopyButton from "../../CopyButton";
import { INITIAL_DATA_PARAMS } from "../../../constants/store";

const cost_types = [
  { label: "CPI", value: "cpi" },
  { label: "Agency commission", value: "a_c" },
  { label: "CPA", value: "cpa" },
  { label: "Revenue share model", value: "r_m" },
];

class OfferInfoForm extends React.Component {
  constructor(props) {
    super();

    // let date = [
    //   new Date(new Date().setDate(new Date().getDate() - 1)),
    //   new Date()
    // ]

    let date = [new Date(new Date().setDate(new Date().getDate() - 1))];

    if (props.offer?.date_from) {
      date = [new Date(props.offer.date_from)];
    }

    // if (props.offer?.date_to) {
    //   date[1] = new Date(props.offer.date_to)
    // }

    let cost_type = "";
    if (props.offer?.active_costs_of_regions[0]?.cost_type) {
      cost_type = cost_types.find(
        i => i.value === props.offer?.active_costs_of_regions[0].cost_type
      ).value;
    }

    this.state = {
      isFormSubmit: false,
      cost_type,
      date_range: date,
      deleteAlert: null,
      isOpen: false,
      render: true,
      firstFormStyle: [{ float: "left", margin: "0" }],
      modalCommit: false,
      stickyFormStyle: [
        {
          float: "right",
          paddingLeft: "12px",
          position: "sticky",
          top: "80px",
          marginBottom: "37px",
        },
      ],
      advertisingAccountsOptions: [],
      offerIsRent: undefined,
      windowWidth: window.innerWidth,
      requiredCabinets: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.setState({
      offerIsRent: this.onWhatIsRent(),
    });
    if (window.history?.state?.add_to_history) {
      window.history.replaceState({}, "");
    } else if (!this.props.isHistory) {
      /*const {
        current_offer,
        isLoading,
        isLoadingEvents,
        countries,
        cabinets,
        offer_data,
        events
      } = this.props;

      console.log("offerInfoForm", {
        offer_data,
        current_offer,
        isLoading,
        events,
        isLoadingEvents,
        countries,
        cabinets
      });*/

      // if (
      //   !(this.props.isLoading || this.props.offer_data?.currencies?.length > 0)
      // ) {
      this.handleGetOfferData();
      // }

      // EXPERIMENTAL
      // if (!(this.props.isLoadingEvents || this.props.events?.length > 0)) {
      //   this.handleGetEvents();
      // }

      if (!(this.props.countries?.length > 0)) {
        this.props.getMetaCountries();
      }

      if (!(this.props.cabinets_loading || this.props.cabinets?.length > 0)) {
        this.props.getCampaignCabinetsList({ sizePerPage: 0 });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // EXPERIMENTAL

    // if (!(this.props.cabinets_loading || this.props.cabinets?.length > 0)) {
    //   this.props.getCampaignCabinetsList({ sizePerPage: 0 });
    // }

    if (!(this.props.cabinets_loading || this.props.cabinets?.length > 0)) {
      this.props.getCampaignCabinetsList({ sizePerPage: 0 });
    }

    if (
      prevProps.offer_data !== this.props.offer_data &&
      this.props.offer_data?.applications
    ) {
      let params = {};
      if (this.props.offer?.app) {
        params.tracker_app_id = this.props.offer_data.applications.find(
          i => i.value == this.props.offer?.app
        ).app_id;
      }
      this.props.getEvents(params);
    }
    if (
      prevProps.cabinets !== this.props.cabinets &&
      Array.isArray(this.props.cabinets)
    ) {
      this.onGetAdvertisingAccountsSorted();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.props.setCampaignCabinets(INITIAL_DATA_PARAMS);
  }

  handleResize = e => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handleGetEvents = (params = {}) => {
    this.props.getEvents(params);
  };

  handleGetOfferData = (params = {}) => {
    this.props.getOfferData({ client_id: this.props.client_id, ...params });
  };

  handleChangeCostType = cost_type =>
    this.setState({ ...this.state, cost_type: cost_type?.value });

  handleChangeAdvertising = ad => {
    this.setState({ ...this.state, advertising_acc: ad });
  };

  handleChangeContact = ct => {
    this.setState({
      ...this.state,
      contact_form: ct,
    });
  };

  handleChangeApplications = val => {
    let params = [];
    if (val.length) {
      val.map(i => {
        params.push(i.app_id);
      });
    } else {
      params.push(val.app_id);
    }
    this.props.getEvents({
      tracker_app_id: params.join(),
    });
  };

  handleDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  onSubmitForm = (e, errors, params) => {
    this.setState({ isFormSubmit: true });
    if (errors?.length !== 0) {
      const i = document
        .querySelector(".is-invalid")
        .parentNode.parentNode.getBoundingClientRect().top;
      window.scroll(undefined, i + window.scrollY - 150);
    }

    if (errors?.length === 0 && this.state.cost_type !== "") {
      const getDate = date => {
        // date.toLocaleDateString().split('.').reverse().join('-');
        let m = date.getMonth() + 1;
        let d = date.getDate();
        const y = date.getFullYear();
        m = m > 9 ? m : `0${m}`;
        d = d > 9 ? d : `0${d}`;
        return `${y}-${m}-${d}`;
      };

      let data = {
        ...params,
        date_from: getDate(this.state.date_range[0]),
        // date_to: getDate(this.state.date_range[1])
        // date_range: getDate(this.state.date_range[0]) + " - " + getDate(this.state.date_range[1])
      };

      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        } else if (Array.isArray(data[key])) {
          data[key] = data[key].map(i => i.value);
        } else if (data[key]?.value) {
          data[key] = data[key].value;
        } else if (!!Number(data[key])) {
          data[key] = +data[key];
        }
      }

      if (!data?.offer_code) {
        data.use_offer_code = false;
      } else {
        data.use_offer_code = true;
      }

      if (data.cpa__cohort_days_quantity) {
        data.cpa__is_cohort = true;
      }

      if (data.r_m__cohort_days_quantity) {
        data.r_m__is_cohort = true;
      }

      if (data.cpa__custom_event_name) {
        data.cpa__is_custom_event = true;
      }

      if (data.r_m__custom_event_name) {
        data.r_m__is_custom_event = true;
      }

      if (this.state?.increase_by_kpi_indicator) {
        data.increase_by_kpi_indicator = true;
      } else {
        data.increase_by_kpi_indicator = false;
      }

      data.change_cr_formula = !!data.cr_formula;

      data.change_roi_formula = !!data.roi_formula;

      data.change_profit_formula = !!data.profit_formula;

      if (data.cpa__is_unique) {
        data.unique_events = true;
      } else {
        data.unique_events = true;
      }

      if (!data?.custom_currency) {
        data.custom_currency = null;
      }

      let payment_data = {};

      for (const key in data) {
        const split = key.split("|");
        if (split.length === 3) {
          const k = split[1];
          if (!payment_data[k]) {
            payment_data[k] = {
              cost_type: data.cost_type,
            };
          }

          payment_data[k][split[0]] = data[key];

          if (split[0].indexOf("unique_events") !== -1) {
            payment_data[k][`unique_events`] = payment_data[k][`unique_events`] === 1;
          }

          if (split[0].indexOf("kpi_is_unique") !== -1) {
            payment_data[k][`kpi_is_unique`] =
              payment_data[k][`kpi_is_unique`] === 1;
          }

          if (split[0].indexOf("kpi_cohort_days_quantity") !== -1) {
            const n = split[0].split("__")[0];
            payment_data[k][`${n}__kpi_is_cohort`] = true;
          }

          if (split[0].indexOf(`r_m__cohort_days_quantity`) !== -1) {
            const n = split[0].split("__")[0];
            payment_data[k][`${n}__is_cohort`] = true;
          }

          if (split[0].indexOf(`cpa__cohort_days_quantity`) !== -1) {
            const n = split[0].split("__")[0];
            payment_data[k][`${n}__is_cohort`] = true;
          }

          if (split[0].indexOf(`cpi__cohort_days_quantity`) !== -1) {
            const n = split[0].split("__")[0];
            payment_data[k][`${n}__is_cohort`] = true;
          }

          if (split[0].indexOf("kpi_custom_event") !== -1) {
            payment_data[k][`kpi_is_custom_event`] = true;
          }

          if (split[0].indexOf("custom_event_name") !== -1) {
            const n = split[0].split("_")[0];
            if (n === "kpi_custom_event_name") {
              payment_data[k][`kpi_is_custom_event`] = true;
            } else {
              payment_data[k][`is_custom_event`] = true;
            }
          }

          delete data[key];
        }
      }

      data.regions = Object.keys(payment_data).map(i => payment_data[i]);

      if (
        !this.props.offer ||
        this.props.isHistory ||
        data.date_from <= this.props.offer.date_from
      ) {
        this.props.onSubmit({
          ...data,
          is_rent: this.state.offerIsRent,
          my_client: this.props.client_id,
        });
      } else {
        this.setState({
          modalCommit: {
            ...data,
            is_rent: this.state.offerIsRent,
            my_client: this.props.client_id,
          },
        });
      }
    }
  };

  onWhatIsRent = () => {
    const { is_rent, offer } = this.props;
    if (offer) {
      return offer.is_rent;
    } else {
      return is_rent == 1 ? true : false;
    }
  };

  onCommit = (is_add_to_history = false, params = {}) => {
    this.props.onSubmit(
      {
        ...this.state.modalCommit,
        ...params,
      },
      is_add_to_history
    );

    this.setState({ modalCommit: null });
  };

  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  onClickModalConfirm = (text, ref) => {
    if (!text || text.length < 3) {
      ref.current.handleSubmit();
      return void 0;
    }
    this.onCommit(true, { change_description: text });
  };

  onGetAdvertisingAccountsSorted = id => {
    const { cabinets, offer } = this.props;
    if (offer?.media_source) {
      let dt = [];
      cabinets?.map(i => {
        if (i.ad_platform == this.props.offer.media_source) {
          dt.push({
            value: i.id,
            label: i?.custom_name != null ? i.custom_name : i.name,
          });
        }
      });
      this.setState({
        advertisingAccountsOptions: dt,
      });
    }
    //  else {
    //   this.setState({
    //     advertisingAccountsOptions: cabinets?.map(i => ({
    //       value: i.id,
    //       label: i.name,
    //     })),
    //   });
    // }
  };

  onGetAdvertisingAccountsByCabinet = id => {
    this.setState({ isFormSubmit: false })

    const { cabinets } = this.props;
    let dt = [];


    if ([8, 15, 17, 18, 19, 21, 22, 23, 24, 25].includes(id)) {
      this.setState({
        requiredCabinets: false
      })
    } else {
      this.setState({
        requiredCabinets: true
      })
    }

    cabinets?.map(i => {
      if (i.ad_platform == id) {
        dt.push({
          value: i.id,
          label: i?.custom_name != null ? i.custom_name : i.name,
        });
      }
    });

    this.setState({
      advertisingAccountsOptions: dt,
    });
  };

  render() {
    const { offer_data, events } = this.props;
    const app_label = this.props.offer ? "Application" : "Applications";

    const perms = ['is_admin', 'is_accountmanager', 'is_head_of_accountmanager'];
    const canEdit = Object.values(this.props.permissions).some(v => perms.includes(v))

    return (
      <AddOfferFormsStyled>
        <AvForm className="needs-validation" onSubmit={this.onSubmitForm}>
          <Col
            sm={9}
            style={
              (this.state.windowWidth > 580 && this.state.firstFormStyle[0]) ||
              {}
            }
          >
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-3 d-flex align-items-center">
                      {this.props.onExit && (
                        <ExitButton
                          className="me-2"
                          onClick={this.props.onExit}
                        >
                          <i className="mdi mdi-arrow-left font-size-22" />
                        </ExitButton>
                      )}
                      <span className="">Offer information</span>
                    </h4>
                    <div className="">
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom01">
                              Offer name:
                            </Label>
                            <AvField
                              name="name"
                              placeholder="Offer name"
                              value={this.props.offer?.name || ""}
                              disabled={!canEdit}
                              type="text"
                              errorMessage="Enter offer name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="validationCustom01"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="">Project Manager:</Label>
                            <CustomSelect
                              name="manager"
                              options={offer_data.users}
                              placeholder="Select manager..."
                              classNamePrefix="select2-selection"
                              errorMessage="Manager field is required"
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.manager
                              )}
                              isLoading={this.props.isLoading}
                              required
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {!this.state.offerIsRent && (
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom02">
                                {app_label}:
                              </Label>
                              <CustomSelect
                                name="applications"
                                options={offer_data.applications}
                                placeholder={`Select ${app_label}`}
                                isMulti={!this.props.offer}
                                classNamePrefix="select2-selection"
                                errorMessage={`${app_label} field is required!`}
                                isLoading={this.props.isLoading}
                                defaultValue={getDefaultValueForSelect(
                                  this.props.offer?.app
                                )}
                                required
                                onChange={this.handleChangeApplications}
                                isFormSubmit={this.state.isFormSubmit}
                              />
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Media source:{" "}
                              <StyledIcon
                                className="dripicons-question"
                                id="media-source"
                              />
                              <Tooltip
                                placement="right"
                                isOpen={this.state.isOpen}
                                autohide={false}
                                toggle={this.toggle}
                                target="media-source"
                              >
                                You can see list of media source{" "}
                                <StyledText>
                                  <Link to="/sources" target="_blank">
                                    here
                                  </Link>
                                </StyledText>
                              </Tooltip>
                            </Label>
                            <CustomSelect
                              name="media_source"
                              options={offer_data.media_sources}
                              placeholder="Select media source..."
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.media_source
                              )}
                              onChange={e =>
                                this.onGetAdvertisingAccountsByCabinet(e.value)
                              }
                              isDisabled={this.props.isHistory}
                              classNamePrefix="select2-selection"
                              errorMessage="Media source field is required!"
                              isLoading={this.props.isLoading}
                              required
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="">Date from:</Label>
                            <InputGroup>
                              <Flatpickr
                                className="form-control d-block bg-white"
                                placeholder="dd M,yyyy"
                                onChange={e => this.setState({ date_range: e })}
                                options={{
                                  defaultDate: this.state.date_range,
                                  // mode: "range",
                                  minDate: this.props.offer?.parent_date_from,
                                  dateFormat: "Y-m-d",
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        {!this.state.offerIsRent && (
                          <>
                            <Col md={6}>
                              <FormGroup className="mb-3">
                                <CheckboxCollapse
                                  id="cr-formula-id"
                                  title="Offer naming"
                                  defaultChecked={
                                    this.props.offer?.use_offer_code
                                  }
                                >
                                  {/*<Label>Budget:</Label>*/}
                                  <CustomSelect
                                    name="offer_code"
                                    // options={optionGroup}
                                    placeholder="Create offer naming..."
                                    classNamePrefix="select2-selection"
                                    errorMessage="Offer naming field is required!"
                                    // isLoading={this.props.isLoading}
                                    defaultValue={getDefaultValueForSelect(
                                      this.props.offer?.offer_code
                                    )}
                                    isMulti
                                    creatable
                                    // required
                                    isFormSubmit={this.state.isFormSubmit}
                                  />
                                </CheckboxCollapse>
                              </FormGroup>
                            </Col>
                            {/* <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom02">
                                Offer naming:{" "}
                                <StyledIcon
                                  className="dripicons-question"
                                  id="offer-naming"
                                />
                                <StyledToolTip
                                  placement="right"
                                  autohide={false}
                                  target="offer-naming"
                                >
                                  Offer naming describe first word in
                                  campaign&apos;s name.
                                </StyledToolTip>
                              </Label>
                              <CustomSelect
                                name="offer_code"
                                // options={optionGroup}
                                placeholder="Create offer naming..."
                                classNamePrefix="select2-selection"
                                errorMessage="Offer naming field is required!"
                                // isLoading={this.props.isLoading}
                                defaultValue={getDefaultValueForSelect(
                                  this.props.offer?.offer_code
                                )}
                                isMulti
                                creatable
                                required
                                isFormSubmit={this.state.isFormSubmit}
                              />
                            </FormGroup>
                          </Col> */}
                          </>
                        )}
                        <Col md="3">
                          <FormGroup className="mb-3">
                            <Label>Budget:</Label>
                            <SelectWithInput
                              select_name="budget_currency"
                              options={offer_data.currencies}
                              defaultValue={{
                                label:
                                  this.props.offer?.budget_currency || "USD",
                                value:
                                  this.props.offer?.budget_currency || "USD",
                              }}
                              isLoading={this.props.isLoading}
                              required
                              inputOptions={{
                                name: "budget",
                                placeholder: "Budget",
                                type: "number",
                                value: this.props.offer?.budget || "",
                                errorMessage: "Enter budget",
                                validate: { required: { value: true } },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="cr-formula-id"
                              title="Custom currency"
                              defaultChecked={this.props.offer?.custom_currency > 0}
                            >
                              {/*<Label>Budget:</Label>*/}
                              <SelectWithInput
                                select_name="custom_currency_currency"
                                options={offer_data.currencies}
                                defaultValue={{
                                  label:
                                    this.props.offer
                                      ?.custom_currency_currency || "USD",
                                  value:
                                    this.props.offer
                                      ?.custom_currency_currency || "USD",
                                }}
                                isLoading={this.props.isLoading}
                                required
                                inputOptions={{
                                  name: "custom_currency",
                                  placeholder: "Custom currency",
                                  type: "number",
                                  value:
                                    this.props.offer?.custom_currency || "",
                                  errorMessage: "Enter custom currency",
                                  validate: { required: { value: true } },
                                }}
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Advertising Accounts:
                            </Label>
                            <CustomSelect
                              name="cabinets"
                              options={this.state.advertisingAccountsOptions}
                              placeholder={`Select cabinets...`}
                              isMulti
                              onChange={this.handleChangeAdvertising}
                              classNamePrefix="select2-selection"
                              errorMessage={`Cabinets field is required`}
                              isLoading={this.props.cabinets_loading}
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.cabinets ||
                                this.state?.advertising_acc
                              )}
                              required={this.state.requiredCabinets}
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Contract:
                            </Label>
                            <CustomSelect
                              name="contract"
                              options={
                                Array.isArray(offer_data.contracts)
                                  ? offer_data.contracts?.map(i => ({
                                    value: i.id,
                                    label: `${i.counterparty_name} ${i?.date_of_signature && `[${i.date_of_signature}]`}`,
                                  }))
                                  : []
                              }
                              placeholder={`Select contractor...`}
                              classNamePrefix="select2-selection"
                              errorMessage={`Contractor field is required!`}
                              onChange={this.handleChangeContact}
                              isLoading={this.props.isLoading}
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.contract?.id ||
                                this.state?.contact_form
                              )}
                              // required
                              isFormSubmit={this.state.isFormSubmit}
                            />
                          </FormGroup>
                        </Col>
                        {!this.state.offerIsRent && (
                          <Col md="6">
                            <>
                              {this.props.offer?.autogenerate_id && (
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom02">
                                    Autogenerate id:
                                  </Label>
                                  <p className="mb-0 mt-1 d-flex align-items-center">
                                    <CopyButton
                                      text={this.props.offer.autogenerate_id}
                                    >
                                      <span className="font-size-18 me-2">
                                        {this.props.offer.autogenerate_id}
                                      </span>
                                    </CopyButton>
                                  </p>
                                </FormGroup>
                              )}
                            </>
                            {/* )} */}
                          </Col>
                        )}
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col
            sm={3}
            style={
              (this.state.windowWidth > 580 && this.state.stickyFormStyle[0]) ||
              {}
            }
          >
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-3">
                      Formulas and coefficients
                    </h4>
                    <div className="">
                      <Row>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              defaultChecked={
                                !!this.props.offer?.display_active_payment_coef
                              }
                              id="payment-coef-id"
                              title="Payment coef"
                            >
                              <AvField
                                name="payment_coef"
                                placeholder="Payment coef"
                                type="number"
                                value={
                                  this.props.offer
                                    ?.display_active_payment_coef || ""
                                }
                                className="form-control"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Please, enter a payment coef",
                                  },
                                  // pattern: {value: '^[A-Za-z0-9]+$', errorMessage: 'Your name must be composed only with letter and numbers'},
                                  // minLength: {value: 6, errorMessage: 'Your name must be between 6 and 16 characters'},
                                  // maxLength: {value: 16, errorMessage: 'Your name must be between 6 and 16 characters'}
                                }}
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="spend-coef-id"
                              title="Spend coef"
                              defaultChecked={
                                !!this.props.offer
                                  ?.display_active_fact_spend_coef
                              }
                            >
                              <AvField
                                name="spend_coef"
                                placeholder="Spend coef"
                                type="number"
                                value={
                                  this.props.offer
                                    ?.display_active_fact_spend_coef || ""
                                }
                                className="form-control"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please, enter a spend coef",
                                  },
                                  // pattern: {value: '^[A-Za-z0-9]+$', errorMessage: 'Your name must be composed only with letter and numbers'},
                                  // minLength: {value: 6, errorMessage: 'Your name must be between 6 and 16 characters'},
                                  // maxLength: {value: 16, errorMessage: 'Your name must be between 6 and 16 characters'}
                                }}
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="revenue-coef-id"
                              title="Revenue coef"
                              defaultChecked={
                                !!this.props.offer
                                  ?.display_active_fact_revenue_coef
                              }
                            >
                              <AvField
                                name="revenue_coef"
                                placeholder="Revenue coef"
                                type="number"
                                value={
                                  this.props.offer
                                    ?.display_active_fact_revenue_coef || ""
                                }
                                // errorMessage="Enter payment coef"
                                className="form-control"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Please, enter a revenue coef",
                                  },
                                  // pattern: {value: '^[A-Za-z0-9]+$', errorMessage: 'Your name must be composed only with letter and numbers'},
                                  // minLength: {value: 6, errorMessage: 'Your name must be between 6 and 16 characters'},
                                  // maxLength: {value: 16, errorMessage: 'Your name must be between 6 and 16 characters'}
                                }}
                              // id="validationCustom01"
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="days-quantity-for-pr-id"
                              title="Days quantity for RR"
                              defaultChecked={
                                !!this.props.offer?.rr_kpi &&
                                this.props.offer.rr_kpi !== 1
                              }
                            >
                              <AvField
                                name="rr_kpi"
                                placeholder="Days quantity for PR..."
                                type="number"
                                value={this.props.offer?.rr_kpi || ""}
                                // errorMessage="Enter payment coef"
                                className="form-control"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Please, enter a days quantity for PR",
                                  },
                                  // pattern: {value: '^[A-Za-z0-9]+$', errorMessage: 'Your name must be composed only with letter and numbers'},
                                  // minLength: {value: 6, errorMessage: 'Your name must be between 6 and 16 characters'},
                                  // maxLength: {value: 16, errorMessage: 'Your name must be between 6 and 16 characters'}
                                }}
                              // id="validationCustom01"
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="roi-formula-id"
                              title="ROI formula"
                              defaultChecked={
                                this.props.offer?.change_roi_formula
                              }
                            >
                              <CustomSelect
                                name="roi_formula"
                                options={offer_data.formulas}
                                placeholder="Select ROI formula..."
                                defaultValue={getDefaultValueForSelect(
                                  this.props.offer?.roi_formula
                                )}
                                classNamePrefix="select2-selection"
                                errorMessage="ROI formula field is required!"
                                isLoading={this.props.isLoading}
                                isFormSubmit={this.state.isFormSubmit}
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="profit-formula-id"
                              title="Profit formula"
                              defaultChecked={
                                this.props.offer?.change_profit_formula
                              }
                            >
                              <CustomSelect
                                name="profit_formula"
                                options={offer_data.formulas}
                                placeholder="Select profit formula..."
                                classNamePrefix="select2-selection"
                                defaultValue={getDefaultValueForSelect(
                                  this.props.offer?.profit_formula
                                )}
                                errorMessage="Profit formula field is required!"
                                isLoading={this.props.isLoading}
                                isFormSubmit={this.state.isFormSubmit}
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="increase-by-kpi-indicator"
                              name="increase_by_kpi_indicator"
                              title="Proportional increase payment by KPI"
                              defaultChecked={
                                this.props.offer?.increase_by_kpi_indicator
                              }
                              onChange={e =>
                                this.setState({ increase_by_kpi_indicator: e })
                              }
                              end
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <CheckboxCollapse
                              id="cr-formula-id"
                              title="CR formula"
                              defaultChecked={
                                this.props.offer?.change_cr_formula
                              }
                              isDisabled
                            >
                              <CustomSelect
                                name="cr_formula"
                                options={offer_data.formulas}
                                placeholder="Select CR formula..."
                                classNamePrefix="select2-selection"
                                defaultValue={getDefaultValueForSelect(
                                  this.props.offer?.cr_formula
                                )}
                                errorMessage="CR formula field is required!"
                                isLoading={this.props.isLoading}
                                isFormSubmit={this.state.isFormSubmit}
                                isDisabled
                              />
                            </CheckboxCollapse>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-3">Events</h4>
                    <div className="">
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              CPA events:
                            </Label>
                            <CustomSelect
                              name="cpa_events"
                              options={events}
                              placeholder="Select CPA events..."
                              isMulti
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.active_cpa_events
                              )}
                              classNamePrefix="select2-selection"
                              errorMessage="CPA events field is required!"
                              isFormSubmit={this.state.isFormSubmit}
                              isLoading={this.props.isLoadingEvents}
                              isDisabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              CR events:
                            </Label>
                            <CustomSelect
                              name="cr_events"
                              options={events}
                              placeholder="Select CR events..."
                              isMulti
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.active_cr_events
                              )}
                              classNamePrefix="select2-selection"
                              errorMessage="Cr events field is required!"
                              isFormSubmit={this.state.isFormSubmit}
                              isLoading={this.props.isLoadingEvents}
                              isDisabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              CAC events:
                            </Label>
                            <CustomSelect
                              name="cac_events"
                              options={events}
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.active_cac_events
                              )}
                              placeholder="Select CAC events..."
                              isMulti
                              classNamePrefix="select2-selection"
                              errorMessage="Cac events field is required!"
                              isFormSubmit={this.state.isFormSubmit}
                              isLoading={this.props.isLoadingEvents}
                              isDisabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Revenue events:
                            </Label>
                            <CustomSelect
                              name="revenue_events"
                              options={events}
                              placeholder="Select revenue events..."
                              isMulti
                              defaultValue={getDefaultValueForSelect(
                                this.props.offer?.active_revenue_events
                              )}
                              classNamePrefix="select2-selection"
                              errorMessage="Revenue events field is required!"
                              isFormSubmit={this.state.isFormSubmit}
                              isLoading={this.props.isLoadingEvents}
                              isDisabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col sm={9}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <Row className="m-0 w-100 justify-content-md-center">
                      <Col md={12} className="p-0">
                        <h4 className="card-title mb-3">Cost</h4>
                        <FormGroup className="mb-3">
                          <Label htmlFor="">Cost type:</Label>
                          <CustomSelect
                            name="cost_type"
                            options={cost_types}
                            placeholder="Select cost type..."
                            classNamePrefix="select2-selection-cost-type"
                            errorMessage="Cost type field is required"
                            defaultValue={getDefaultValueForSelect(
                              this.props.offer?.active_costs_of_regions[0]
                                ?.cost_type
                            )}
                            onChange={this.handleChangeCostType}
                            isLoading={this.props.isLoading}
                            required
                            isFormSubmit={this.state.isFormSubmit}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md={6}>
                        <FormGroup className="mb-3"></FormGroup>
                      </Col> */}
                    </Row>
                    {this.state.render && (
                      <PaymentType
                        type={this.state.cost_type}
                        isLoading={this.props.isLoadingEvents}
                        offer_data={this.props.offer_data}
                        isFormSubmit={this.state.isFormSubmit}
                        events={events}
                        offer={this.props.offer}
                        cost_data={this.props.offer?.active_costs_of_regions}
                        countries={this.props.countries}
                      // countries={countries__}
                      />
                    )}
                    {/*<FormByCostType*/}
                    {/*  type={this.state.cost_type}*/}
                    {/*  isLoading={this.props.isLoadingEvents}*/}
                    {/*  offer_data={this.props.offer_data}*/}
                    {/*  isFormSubmit={this.state.isFormSubmit}*/}
                    {/*  events={events}*/}
                    {/*  offer={this.props.offer}*/}
                    {/*/>*/}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          {this.state.deleteAlert && (
            <SweetAlert
              showCancel
              confirmBtnText="Delete"
              cancelBtnText="Cancel"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle=""
              title={this.state.deleteAlert.title}
              onCancel={() => this.handleDeleteAlert(null)}
              onConfirm={this.state.deleteAlert.onConfirm}
            >
              <p>You are about to delete this offer ?</p>
              <p>If you are not sure, you can close this form.</p>
            </SweetAlert>
          )}
          <Col xl={12}>
            <Card className="bg-transparent shadow-none">
              <Row>
                <Col sm={12}>
                  <div className="text-start d-flex">
                    {!this.props.readOnly && (
                      <Button
                        color="primary"
                        type="submit"
                        className={`float-start ${this.state.windowWidth < 580 && `mb-3 w-100`
                          }`}
                      >
                        Save changes
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </AvForm>

        <DynamicModalWithInput
          isOpen={!!this.state.modalCommit}
          toggle={() => this.setState({ modalCommit: !this.state.modalCommit })}
          action={() => this.onCommit(false)}
          header="Description"
          alertColor="primary"
          text="if you want to save the previous version in history, enter a description of the main thing you changed?"
          alertText={`If you click "Save to history", the previous offer will be saved in the change history and you will be able to view it in the future.`}
          isInput
          buttonText="Save"
          additionalButton={{
            name: "Save to history",
            onClick: this.onClickModalConfirm,
          }}
          canDisableButtonConfirm={false}
        />
      </AddOfferFormsStyled>
    );
  }
}

OfferInfoForm.defaultProps = {
  isHistory: false,
};

OfferInfoForm.propTypes = {
  client_id: PropTypes.any,
  is_rent: PropTypes.bool,
  getOfferData: PropTypes.func,
  getEvents: PropTypes.func,
  isLoading: PropTypes.bool,
  isLoadingEvents: PropTypes.bool,
  offer_data: PropTypes.any,
  current_offer: PropTypes.any,
  events: PropTypes.any,
  onSubmit: PropTypes.func,
  offer: PropTypes.any,
  countries: PropTypes.array,
  getMetaCountries: PropTypes.func,
  not_render: PropTypes.any,
  getCampaignCabinetsList: PropTypes.func,
  cabinets: PropTypes.any,
  cabinets_loading: PropTypes.bool,
  isHistory: PropTypes.bool,
  onExit: PropTypes.func,
  readOnly: PropTypes.bool,
  setCampaignCabinets: PropTypes.func,
  permissions: PropTypes.any,
};

const ExitButton = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: 0.2s;
  width: 35px;
  height: 35px;
  cursor: pointer;

  &:hover {
    background-color: rgba(204, 204, 204, 0.42);
  }
`;

const AddOfferFormsStyled = styled.div``;

const StyledIcon = styled.i`
  //vertical-align: middle;
  vertical-align: -2.5px;
  color: #5580ff;
`;

const StyledText = styled.span`
  text-decoration: underline;
  color: blue;
`;

const StyledToolTip = styled(UncontrolledTooltip)`
  //.tooltip {
  //  background: #333;
  //  border-radius: 5px;
  //  padding: 10px;
  //  color: whitesmoke;
  //  margin-left: 5px;
  //}
  //
  //.tooltip-arrow {
  //  content: "";
  //  background: #333;
  //}
  //
  //.tooltip::after {
  //  position: absolute;
  //  left: -7px;
  //  top: 43%;
  //  content: '';
  //  width: 15px;
  //  height: 15px;
  //  background: #333;
  //  transform: rotate(45deg);
  //}
`;

const mapStateToProps = state => ({
  offer_data: state.Offers.offer_data,
  current_offer: state.Offers.offer,
  isLoading: state.Offers.loading_offer_data,
  events: state.Events.events,
  isLoadingEvents: state.Events.loading_events,
  countries: state.Meta.countries,
  cabinets: state.CampaignAdvertisingAccountList.data,
  cabinets_loading: state.CampaignAdvertisingAccountList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getOfferData,
  getEvents,
  getMetaCountries,
  getCampaignCabinetsList: getCampaignAdvertisingAccountsList,
  setCampaignCabinets: setCampaignAdvertisingAccountsList,
})(OfferInfoForm);
